import { LegacyStack } from '@shopify/polaris'
import React from 'react'

import { LegacyHelpIcon } from '../common/HelpIcon'
import { PersonalInfo } from '../common/PersonalInfo'

export const DetailsItem = ({
  label,
  helpIcon,
  children,
}: {
  label: React.ReactNode
  helpIcon?: React.ReactNode
  children: any
}) => (
  <LegacyStack distribution="equalSpacing" spacing="extraTight">
    <span>
      {label}:{helpIcon && <LegacyHelpIcon>{helpIcon}</LegacyHelpIcon>}
    </span>
    <span children={children} />
  </LegacyStack>
)

export const LongDetailsItem = ({
  label,
  content,
  hasPersonalInfo,
}: {
  label: React.ReactNode
  content: string
  hasPersonalInfo?: boolean
}) => (
  <div
    style={{
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      columnGap: '8px',
    }}
  >
    <div style={{ whiteSpace: 'nowrap' }}>{label}:</div>
    <div
      style={{
        textAlign: 'right',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      title={content}
    >
      {hasPersonalInfo ? <PersonalInfo>{content}</PersonalInfo> : content}
    </div>
  </div>
)
